module.exports = __webpack_public_path__ + "static/frost_giant-a532db22647b5e377e0e65ca3e1f0b12.jpg";